<span class="badge"
      [class.badge-success]="status === 'SUCCESS'"
      [class.badge-danger]="status === 'ERROR'"
      [class.badge-primary]="status === 'QUEUED'">
    {{status}}
</span>

